import { Heart } from "common/Heart";
import { CTA } from "common/styleguide/CTA";
import { routeActions, routeSelectors } from "data/resources/routes";
import { tripActions, tripSelectors } from "data/resources/trips";
import React, { useState } from "react";
import { connect } from "react-redux";
import styles from "./HeartButton.scss";

const resource = (objectType) => {
  switch (objectType) {
    case "trip":
      return { actions: tripActions, selectors: tripSelectors };
    case "route":
      return { actions: routeActions, selectors: routeSelectors };
    default:
      console.warn(`Unexpected likable ${objectType}`);
  }
};

export const _HeartButton = ({ object, like, unlike }) => {
  const [posting, setPosting] = useState(false);
  const { likedByCurrentUser, likesCount } = object;
  const onClick = () => {
    if (posting) {
      return;
    }
    setPosting(true);
    (likedByCurrentUser ? unlike : like)().then(() => setPosting(false));
  };

  return (
    <CTA secondary className={styles.HeartButton} onClick={onClick}>
      <Heart liked={likedByCurrentUser} count={likesCount} capitalized />
    </CTA>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { selectors } = resource(ownProps.objectType);
  return {
    object: selectors.find(state, ownProps.objectId),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { objectType, objectId } = ownProps;
  const { actions } = resource(objectType);
  return {
    like: () => dispatch(actions.like(objectId)),
    unlike: () => dispatch(actions.unlike(objectId)),
  };
};

export const HeartButton = connect(mapStateToProps, mapDispatchToProps)(_HeartButton);
